import React, { FC, useCallback } from 'react';
import { ServiceEx, ServicePreset } from '../../../../../models/ServicePresets';
import { ExtraServicesMap } from '../../../../../constants/configuration';
import DedicatedIpExSrv from './components/DedicatedIpExSrv/DedicatedIpExSrv';
import FilmsExSrv from './components/FilmsExSrv/FilmsExSrv';
import WifiMonitoringExSrv from './components/WifiMonitoringExSrv/WifiMonitoringExSrv';
import ClientExSrv from './components/ClientExSrv/ClientExSrv';
import { getExtraServiseType } from '../../../../../utils';

interface ExtraServicesProps {
  service: ServicePreset | undefined;
  dedicatedIp: string;
  isDisabled: boolean;
  handleConnectStaticIP: () => void;
  isBrizTvLogin: boolean;
  isShareStillActive: boolean;
  isCurrentServiceSuspension: boolean;
  handleConnectFilms: () => void;
}

const ExtraServices: FC<ExtraServicesProps> = ({
  service,
  dedicatedIp,
  isDisabled,
  handleConnectStaticIP,
  isBrizTvLogin,
  isShareStillActive,
  isCurrentServiceSuspension,
  handleConnectFilms,
}) => {
  const renderComponent = useCallback(
    (type: keyof typeof ExtraServicesMap, srv: ServiceEx) => {
      switch (type) {
        case 'client': {
          return <ClientExSrv key={srv.id} serviceEx={srv} isDisabled={isDisabled} />;
        }
        case 'dedicatedIp': {
          return (
            <DedicatedIpExSrv
              key={srv.id}
              serviceEx={srv}
              dedicatedIP={dedicatedIp}
              isDisabled={isDisabled}
              handleConnectStaticIP={handleConnectStaticIP}
            />
          );
        }
        case 'films': {
          return (
            <FilmsExSrv
              key={srv.id}
              serviceEx={srv}
              isBrizTvLogin={isBrizTvLogin}
              isDisabled={isDisabled}
              isShareStillActive={isShareStillActive}
              isCurrentServiceSuspension={isCurrentServiceSuspension}
              handleConnectFilms={handleConnectFilms}
            />
          );
        }
        case 'wifiMonitoring': {
          return <WifiMonitoringExSrv key={srv.id} serviceEx={srv} isDisabled={isDisabled} />;
        }
        default:
          return null;
      }
    },
    [dedicatedIp, handleConnectStaticIP, isDisabled],
  );

  return (
    <>
      {service?.ServicesEx?.map((srv) => {
        const type = getExtraServiseType(srv.Tags);
        if (!type) return null;
        return renderComponent(type, srv);
      })}
    </>
  );
};

export default ExtraServices;
